import React, { SVGProps } from 'react';
import { getSVGPath } from '../../utils/util';
import { ReactSVG } from 'react-svg';

type Booleanish = boolean | 'true' | 'false';

interface SVGImageProps extends SVGProps<SVGSVGElement> {
  name: string;
  fill?: string;
  'aria-hidden'?: Booleanish;
  className?: string;
  width?: number | string;
  height?: number | string;
  stroke?: string;
  circleFill?: string;
  pathFill?: string;
  testId?: string;
  onClick?: () => void;
}

const SVGImage: React.FC<SVGImageProps> = ({
  name,
  fill,
  className,
  width,
  height,
  stroke,
  'aria-hidden': ariaHidden,
  circleFill,
  pathFill,
  testId,
  onClick,
}) => {
  return (
    <ReactSVG
      data-testid={testId}
      className={`${className} ${testId}`}
      beforeInjection={(svg) => {
        if (width) svg.setAttribute('width', width.toString());
        if (height) svg.setAttribute('height', height.toString());
        if (fill) svg.setAttribute('fill', fill);
        if (ariaHidden) svg.setAttribute('aria-hidden', ariaHidden.toString());
        if (stroke) svg.setAttribute('stroke', stroke);
        if (circleFill) {
          const circle = svg.querySelector('#Circle');
          if (circle) circle.setAttribute('fill', circleFill);
        }
        if (pathFill) {
          const path = svg.querySelector('path');
          if (path) path.setAttribute('fill', pathFill);
        }
      }}
      src={getSVGPath(name)}
      onClick={onClick}
    ></ReactSVG>
  );
};

export default SVGImage;
